/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { type AppDispatch } from '../../../store'
import * as AllConfigDataService from '../services/allConfigService'
import * as FileStatus from '../services/fileStatusService'

// import { type Configuration } from '../services/allConfigService'
import * as CreateConfigurationService from '../services/createConfigService'
import { createConfigurationLoadingAction, createConfigurationUpdateAction, createConfigurationErrorAction } from './addNewConfigSlice'
import { type AllConfigData, allConfigDataErrorAction, allConfigDataLoadingAction, allConfigDateUpdateAction } from './allConfigSlice'
import { fileStatusDataLoadingAction, fileStatusDateUpdateAction, fileStatusDataErrorAction } from './fileStatusSlice'

export const fetchAllConfigs = (page: number, size: number, tenantId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(allConfigDataLoadingAction())

  void AllConfigDataService.getAllConfigData(
    page,
    size,
    tenantId,
    (allConfigData, httpStatus) => {
      dispatch(
        allConfigDateUpdateAction({
          data: allConfigData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(allConfigDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchAllFiles = (page: number, size: number, tenantId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(fileStatusDataLoadingAction())

  void FileStatus.getAllFiles(
    page,
    size,
    tenantId,
    (allConfigData, httpStatus) => {
      dispatch(
        fileStatusDateUpdateAction({
          data: allConfigData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(fileStatusDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const createNewConfig = (configurationTemplate: AllConfigData) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createConfigurationLoadingAction())

  void CreateConfigurationService.createConfiguration(
    configurationTemplate,
    (createConfigurationResponse) => {
      console.log('Testing', createConfigurationResponse)
      dispatch(createConfigurationUpdateAction({ data: createConfigurationResponse }))
    },
    (errorMessage, httpStatus) => {
      dispatch(createConfigurationErrorAction({ errorMessage, httpStatus }))
    }
  )
}
